import React from "react";
import { Col, Row } from "react-bootstrap";
import SpeakerBubble from "../transcription/SpeakerBubble";
import EventQualityReason from "./EventQualityReason";

export default class SpeakerBubbleWithEventQualityReason extends SpeakerBubble {
  constructor(props) {
    super(props);
  }

  renderEventQualityReason = () => {
    const { blockProps } = this.props;
    const metadata = Object.fromEntries(blockProps.data);

    return (
      <EventQualityReason
        eventId={metadata.eventId}
        previousEventQualityReasons={metadata.eventQualityReasons}
        propagateQualityReasonCallback={
          blockProps.propagateQualityReasonCallback
        }
        editReasonOptions={blockProps.editReasonOptions}
        redactReasonOptions={blockProps.redactReasonOptions}
        updateHighlightPreviousPasses={blockProps.updateHighlightPreviousPasses}
        addEventsChangedFromPassCount={blockProps.addEventsChangedFromPassCount}
      />
    );
  };

  render() {
    return (
      <Row className="transcriptQualityRating-speaker-row">
        <Col xs={9}>{super.render()}</Col>
        <Col xs={3}>{this.renderEventQualityReason()}</Col>
      </Row>
    );
  }
}
